import axios from 'axios'
import appStore from '@/AppStore'
import { fileTypeFromBlob } from 'file-type'

export function uploadImagesAndConvertToFile(imagePath = ''): Promise<File> {
  const startIndex = imagePath.lastIndexOf('/') + 1
  const fileName = imagePath.slice(startIndex)

  return new Promise(resolve => {
    axios
      .get(imagePath, { responseType: 'blob' })
      .then(async res => {
        if (res.data instanceof Blob && res.data) {
          // Detect MIME type from content first
          let contentType
          try {
            // Analyze the binary content
            const fileInfo = await fileTypeFromBlob(res.data)
            contentType = fileInfo?.mime
          } catch (e) {
            // Silent error - will fall back to other methods
          }

          // Fallbacks if content detection fails
          if (!contentType) {
            contentType =
              res.headers['content-type'] ||
              inferTypeFromExtension(fileName) ||
              'application/octet-stream'
          }

          const imgFile = new File([res.data], fileName, { type: contentType })
          resolve(imgFile)
        }
      })
      .catch(() => {
        appStore
          .dispatch('notification/pushNotification', {
            type: 'error',
            messages: 'Failed to fetch image due to Invalid URL'
          })
          .finally()
      })
  })
}

// Custom function to infer common MIME types from file extension in case file-type detection fails
function inferTypeFromExtension(filename: string): string | null {
  const ext = filename.split('.').pop()?.toLowerCase()
  if (!ext) return null

  const imageTypes: Record<string, string> = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    webp: 'image/webp',
    svg: 'image/svg+xml',
    bmp: 'image/bmp'
  }

  return imageTypes[ext] || null
}
